export const DIRECTIONS = ["up", "down", "left", "right"] as const;

export type DirectionProps = {
  direction?: typeof DIRECTIONS[number];
};

export default DirectionProps;
